// extracted by css-extract-rspack-plugin
export default {"cls1":"TranslationModal-cls1_xpj","cls2":"TranslationModal-cls2__OH TranslationModal-cls1_xpj"};